import { CheckCircle, XCircle, Clock } from "lucide-react";

var SOURCE_LABELS = {
  consorcio: "Consorcio", carta_contemplada: "Carta Contemplada",
  seguro_vida: "Seguro Vida", seguro_residencial: "Seguro Residencial",
  seguro_auto: "Seguro Auto", plano_saude: "Plano Saude",
  manual: "Manual", cashback: "Cashback", doacao: "Doacao",
};

var STATUS_MAP = {
  pending_approval: { cls: "bg-amber-100 text-amber-700", label: "Pendente", icon: Clock },
  approved: { cls: "bg-emerald-100 text-emerald-700", label: "Aprovada", icon: CheckCircle },
  rejected: { cls: "bg-red-100 text-red-700", label: "Rejeitada", icon: XCircle },
};

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }
function fmtR(v) { return v == null ? "R$ 0,00" : "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2 }); }
function fmtD(d) { return d ? new Date(d).toLocaleDateString("pt-BR") : "-"; }

function TxRow({ tx }) {
  var st = STATUS_MAP[tx.status] || STATUS_MAP.pending_approval;
  var StIcon = st.icon;
  var typeCls = tx.type === "earn" ? "bg-emerald-100 text-emerald-700" :
    tx.type === "redeem" ? "bg-blue-100 text-blue-700" :
    tx.type === "donate" ? "bg-purple-100 text-purple-700" : "bg-gray-100 text-gray-700";
  var typeLabel = tx.type === "earn" ? "Ganho" : tx.type === "redeem" ? "Resgate" : tx.type === "donate" ? "Doacao" : "Ajuste";
  var amtCls = tx.amount >= 0 ? "text-emerald-600" : "text-red-500";
  return (
    <tr className="hover:bg-gray-50 transition-colors" data-testid={"tx-row-" + tx.id}>
      <td className="px-4 py-3 text-gray-500">{fmtD(tx.created_at)}</td>
      <td className="px-4 py-3">
        <p className="font-medium text-[#0A2F3D]">{tx.user_name}</p>
        <p className="text-xs text-gray-400">{tx.user_role === "broker" ? "Vendedor" : "Cliente"}</p>
      </td>
      <td className="px-4 py-3"><span className={"px-2 py-1 text-xs font-medium rounded-full " + typeCls}>{typeLabel}</span></td>
      <td className="px-4 py-3 text-gray-600">{SOURCE_LABELS[tx.source] || tx.source}</td>
      <td className={"px-4 py-3 text-right font-bold " + amtCls}>{tx.amount >= 0 ? "+" : ""}{fmt(tx.amount)}</td>
      <td className="px-4 py-3 text-right text-gray-600">{fmtR(tx.money_value)}</td>
      <td className="px-4 py-3"><span className={"px-2 py-1 text-xs font-medium rounded-full flex items-center gap-1 w-fit " + st.cls}><StIcon className="w-3 h-3" />{st.label}</span></td>
      <td className="px-4 py-3 text-gray-400 text-xs">{fmtD(tx.expires_at)}</td>
    </tr>
  );
}

export default function DoletasTxTable({ transactions, total, loading }) {
  if (loading) {
    return <div className="bg-white rounded-xl border border-gray-200 flex items-center justify-center py-12"><div className="w-6 h-6 border-2 border-[#3B82F6] border-t-transparent rounded-full animate-spin" /></div>;
  }

  var rows = [];
  for (var i = 0; i < transactions.length; i++) {
    rows.push(<TxRow key={transactions[i].id} tx={transactions[i]} />);
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100">
        <h3 className="font-semibold text-[#0A2F3D] text-sm">Todas as Transacoes ({total})</h3>
      </div>
      {transactions.length === 0 ? (
        <div className="py-12 text-center text-gray-400 text-sm">Nenhuma transacao encontrada</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Data</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Usuario</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Tipo</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Fonte</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-right">Doletas</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500 text-right">R$</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Status</th>
                <th className="px-4 py-3 text-xs font-medium text-gray-500">Expira</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">{rows}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
